import '../styles/TopBar.css'
import { countryLabel } from '../utils/countryLabel'

/**
 * Fixed header strip shown when logged in: country name, player name and
 * current balance (kept fresh by App's refreshProfile after each build).
 * Hidden when embedded in an iframe (e.g. GameDashboard integration).
 */
const TopBar = ({ profile }) => {
  // Hide user data when embedded in iframe on another site
  try {
    if (window.self !== window.top) return null
  } catch (_) {
    return null
  }

  const { country_name, country_id, player_name, balance, diplo_points } = profile || {}

  return (
    <div className="map-topbar pr-widget pr-pill pr-gold">
      {country_name && (
        <span className="topbar-item topbar-country" title="Pays">
          🏳️ {countryLabel(country_name, country_id)}
        </span>
      )}
      {player_name && (
        <span className="topbar-item topbar-player" title="Joueur">
          👤 {player_name}
        </span>
      )}
      {balance != null && (
        <span className="topbar-item topbar-balance" title="Balance">
          💰 {Number(balance).toLocaleString('fr-FR')}
        </span>
      )}
      {diplo_points != null && (
        <span className="topbar-item" title="Points diplomatiques">
          🤝 {Number(diplo_points).toLocaleString('fr-FR')} PD
        </span>
      )}
    </div>
  )
}

export default TopBar
